var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{key:"name",attrs:{"type":"text","label":_vm.lable,"rules":_vm.rules,"disabled":_vm.isDisable},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})}
var staticRenderFns = []

export { render, staticRenderFns }